import { ScreenAuthName } from '@dms/screen'

export default ScreenAuthName
